import { ChangeEventHandler } from "react";
import { FieldValues, Path, UseFormRegister } from "react-hook-form";

import { cn } from "../../../lib";
import { Button, Input, Label } from "..";

interface InputButtonProps<TFormValues extends FieldValues> {
	name: Path<TFormValues>;
	handleChange: ChangeEventHandler<HTMLInputElement>;
	register?: UseFormRegister<TFormValues>;
	disabled?: boolean;
	buttonText?: string;
	buttonClassName?: string;
	accept?: string;
	multiple?: boolean;
}

export const InputButton = <TFormValues extends Record<string, unknown>>({
	name,
	handleChange,
	register,
	disabled,
	buttonText = "Click to add file",
	buttonClassName,
	accept,
	multiple = true,
}: InputButtonProps<TFormValues>) => {
	return (
		<div className="flex justify-start items-center">
			<Button variant="outline" asChild aria-haspopup>
				<Label
					htmlFor={name}
					className={cn(
						"cursor-pointer px-2 py-1 text-sm text-gray-600 shadow",
						buttonClassName,
					)}
				>
					{buttonText}
				</Label>
			</Button>
			<Input
				type="file"
				id={name}
				disabled={disabled}
				name={name}
				className="hidden"
				{...(register && register(name))}
				onChange={handleChange}
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				onClick={(event: any) => {
					event.target.value = null;
				}}
				accept={accept}
				multiple={multiple}
			/>
		</div>
	);
};
